<mat-form-field class="example-full-width">
  <mat-label>Ingrese su correo <span> * </span></mat-label>
  <input type="email" #email maxlength="50" matInput formControlName="correo" placeholder="contacto@example.com" required/>
  <mat-error *ngIf="email.invalid">{{getErrorMessage()}}</mat-error>
</mat-form-field>
